import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormGroup, Stack } from "@mui/material";
import DatatypeDropdown from "./DatatypeDropdown";
import CSVForm from "./TemplatePropertyForms/CSVForm";
import DelimitedForm from "./TemplatePropertyForms/DelimitedForm";
import DelimitedMultipleSepForm from "./TemplatePropertyForms/DelimitedMultipleSepForm";
import NVPForm from "./TemplatePropertyForms/NVPForm";
import FixedLengthForm from "./TemplatePropertyForms/FixedLengthForm";
import DatabaseForm from "./TemplatePropertyForms/DatabaseForm";
import DelimitedFieldIdentifierForm from "./TemplatePropertyForms/DelimitedFieldIdentifierForm";
import ServletForm from "./TemplatePropertyForms/ServletForm";
import Hl7Form from "./TemplatePropertyForms/HL7";
import JSONForm from "./TemplatePropertyForms/JSONForm";
import XMLForm from "./TemplatePropertyForms/XMLForm";
import EDIForm from './TemplatePropertyForms/EDIForm'
import ExcelForm from "./TemplatePropertyForms/ExcelForm";
import { treeActions } from "../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import InboundDependency from "./InboundDependency";
import { getRePopulatedData } from "../../utils/rcTreePopulate";
import OutboundTemplatePropertiesFields from "./OutboundTemplatePropertiesFields";
import TradingPartnerData from "./TradingPartnerData";

function TemplateProperties() {
  const [datatype, setDataType] = useState();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const noneSelectedMsg = {
    inbound: t('LBL_NO_IN_SEL'),
    outbound: t('LBL_NO_OUT_TEM_SEL'),
    workflow: t('LBL_NO_WORKFLOW_ITEM_SELECTED')
  }

  useEffect(() => {
    setDataType(rightTree.tree.templateHeader?.FILETYPE);
  }, [rightTree.tree.templateHeader?.FILETYPE]);

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

  return (
    <FormGroup className="height-100 width-100 padding-0 overflow-auto no-flex-wrap">
      <Box className="" sx={{ width: 'calc(100% -  32px) !important', minWidth: 275, padding: '8px 16px' }}>
        <Stack spacing={'16px'} className="tp-segment">
          <DatatypeDropdown
            className={!rightTree.tree.templateHeader.FILETYPE ? 'disabled' : ''}
            datatype={datatype}
            datatypeOnChange={(e, obj) => handleChange('FILETYPE', obj.value)}
          />
          {rightTree.tree.templateHeader.FILETYPE ?
            <>
              {(
                {
                  "CSV": <CSVForm />,
                  "DATABASE": <DatabaseForm />,
                  "DELIMITED": <DelimitedForm />,
                  "DELIM_FLD_ID": <DelimitedFieldIdentifierForm />,
                  "MULIT_DELIMITED": <DelimitedMultipleSepForm />,
                  "EDI": <EDIForm />,
                  "EXCEL": <ExcelForm />,
                  "FIXED_LENGTH": <FixedLengthForm />,
                  "HL7": <Hl7Form />,
                  "JSON": <JSONForm />,
                  "NVP": <NVPForm />,
                  "SERVLET": <ServletForm />,
                  "XML": <XMLForm />
                }[datatype]

              )}
              {parentScreen === 'outbound' && <>
                <InboundDependency datatype={datatype} />
                {datatype !== 'GraphQL' && <>
                  <OutboundTemplatePropertiesFields datatype={datatype} />
                  <TradingPartnerData />
                </>}
              </>}
            </> : (<div className='panel-no-data'>{noneSelectedMsg[parentScreen]}</div>)
          }
        </Stack>
      </Box>
    </FormGroup>
  )
}

export default TemplateProperties;
